import { ProductType } from '../Instruments/ProductType';
import { OperationType } from '../Trading/OperationType';
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectPositionMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_OPENPOSITION);
        this.OrderWasManual = false;
        this.Route = null;
        this.PositionId = '';
        this.Account = null;
        this.Symbol = null;
        // Под нефикс список, для прочих - бери Symbol и не парься
        this.InstrumentID = 0;
        // +++ Это дочерняя позиция - id позиции к которой на привязана
        this.MasterID = null;
        this.OperationType = OperationType.Buy;
        this.Amount = 0;
        this.OpenOrderId = null;
        this.OpenPrice = 0;
        this.OpenTime = null;
        this.CloseOrderId = null;
        this.ClosePrice = 0;
        this.CloseTime = null;
        this.StopLossOrderId = '-1';
        this.StopLossLimit = 0;
        this.TakeProfitOrderId = '-1';
        this.TakeProfitLimit = 0;
        this.Swaps = null;
        this.Commission = null;
        this.Comment = null;
        this.OrderGroupId = 0;
        this.OpenCrossPrice = 0;
        this.InitMargin = 0;
        this.MaintMargin = 0;
        this.SettlementPrice = null;
        this.SettlementCrossPrice = null;
        this.TrailingStop = false;
        this.TrailingOffset = 0;
        // Управление разрешением SLTP на уровне отдельного ордера
        // заводили под интеграции, нашим сервером пока не используется
        this.SLTPAllowed = true;
        this.RealizedPL = 0;
        this.ProductType = ProductType.General;
        // Используется для передачи  данных от строннего вендора
        // (данные считаются в в поставщике, у нас же в клиенте эти данные являются рассчетными)
        // Это поле используется для того чтобы выводить данные "as is"
        this.ServerCalculationCurPriceClose = null;
        // Используется для передачи  данных от строннего вендора
        // (данные считаются в в поставщике, у нас же в клиенте эти данные являются рассчетными)
        // Это поле используется для того чтобы выводить данные "as is"
        this.ServerCalculationExposure = null;
        // Используется для передачи  данных от строннего вендора
        // (данные считаются в в поставщике, у нас же в клиенте эти данные являются рассчетными)
        // Это поле используется для того чтобы выводить данные "as is"
        this.ServerCalculationPositionValue = null;
        // Используется для передачи  данных от строннего вендора
        // (данные считаются в в поставщике, у нас же в клиенте эти данные являются рассчетными)
        // Это поле используется для того чтобы выводить данные "as is"
        this.ServerCalculationNetPL = null;
        // Используется для передачи  данных от строннего вендора
        // (данные считаются в в поставщике, у нас же в клиенте эти данные являются рассчетными)
        // Это поле используется для того чтобы выводить данные "as is"
        this.ServerCalculationGrossPL = null;
        this.IsOnlyServerCalculationUpdate = false;
        this.InstrumentTradableID = null;
        this.OptionExerciseStatus = null;
        this.CorporateActionType = null;
        this.StartOfDayAmount = null;
        this.ProductTypeModifiedAmount = null;
        this.Leverage = null;
        this.AccruedInterest = null;
        this.StrategyId = null;
    }
}
